module.exports = __webpack_public_path__ + "img/shopping-cart-line.b73eadf9.svg";